import { createSlice } from "@reduxjs/toolkit";
const initialState = { themeName: "light" };
const slice = createSlice({
    initialState,
    name: "themeReducers",
    reducers: {
        changeTheme: (state, action) => {
            state.themeName = action.payload;
        }
    }
});
export const themeReducers = slice.reducer;
export const { changeTheme } = slice.actions;
